/* eslint-disable no-undef */
WB.Modules = WB.Modules || {};
WB.Modules.RoutesDirectiveLink = function() {
    return function (scope, element, attr) {
        scope.stories       = null;
        scope.$root.stories = null;

        angular.element(document).bind('click', function (e) {
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            scope.$apply(function () {
            });
        });

        scope.getPageId = function() {
            return scope.$root.ActiveRoute ? scope.$root.ActiveRoute.locals.pageId : null;
        };
    };
};

WB.Modules.RoutesDirective = function() {
    return {
        restrict: 'A',
        link: WB.Modules.RoutesDirectiveLink(),
        template: `<div ng-if="$root.ActiveRoute.locals.controller !== 'appdownload'
        && $root.ActiveRoute.locals.controller !== 'maps'
        && $root.ActiveRoute.locals.controller !== 'privacyPolicy'
        && $root.ActiveRoute.locals.controller !== 'termsOfUse'
        && $root.ActiveRoute.locals.controller !== 'sitemap'
        && $root.ActiveRoute.locals.controller !== 'sitemapcountries'
        && $root.ActiveRoute.locals.controller !== 'sitemapcities'
        && $root.ActiveRoute.locals.controller !== 'sitemapstates'
        && $root.ActiveRoute.locals.controller !== 'sitemapstatecities'
        && $root.ActiveRoute.locals.controller !== 'partners'
        && $root.ActiveRoute.locals.controller !== 'uninstallapp'
        && $root.ActiveRoute.locals.controller !== 'privacyfeedback'
        && $root.ActiveRoute.locals.controller !== 'press'
        && $root.ActiveRoute.locals.controller !== 'pressArticle'
        && $root.ActiveRoute.locals.controller !== 'education'
        && $root.ActiveRoute.locals.controller !== 'weather-widgets'
        ">
     <div id="wb-banner-ad-container">
         <display-ad-widget
            slotId="'wb_banner'"
            width="728"
            height="90"
            showOnPhone="false"
            showOnTablet="false" />
    </div>
</div>
<div class="route-content">
    <div ng-if="$root.ActiveRoute.locals.controller == 'forecasts'">
        <div>
            <breaking-news-view />
        </div>
        <div
            wb-module-forecasts
            location="$root.App.User.ActiveLocation">
        </div>
    </div>
    <div ng-if="$root.ActiveRoute.locals.controller == 'homepage'">
        <div>
            <breaking-news-view />
        </div>
        
        <div
            wb-module-homepage
            location="$root.App.User.ActiveLocation">
        </div>
    </div>
    <div ng-if="$root.ActiveRoute.locals.controller == 'maps'">
        <style>
            .module {
                background-image: none !important;
            }
        </style>
        <maps-screen pageId="'maps'"></maps-screen>
    </div>
    <div ng-if="$root.ActiveRoute.locals.controller == 'alerts'">
        <alerts />
    </div>
    <div ng-if="$root.ActiveRoute.locals.controller == 'life'">
        <style ng-if="!$root.isBreakpointMedium && !$root.isBreakpointSmall">
            .module {
                background-image: url({{$root.App.BackgroundUrl}}) !important;
            }
        </style>
        <style ng-if="$root.isBreakpointMedium || $root.isBreakpointSmall">
            .module {
                background-image: none !important;
            }
        </style>
        <life-page-content-view />
    </div>
    <div ng-if="$root.ActiveRoute.locals.controller === 'news'" ng-cloak>
        <div>
            <breaking-news-view />
        </div>
        <news-videos-page-container-view />
    </div>
    <div ng-if="$root.ActiveRoute.locals.controller === 'weathercategory'" ng-cloak>
        <weather-traffic-cam-container-view camera-page-view-type="'weatherCamCategoryPage'" />
    </div>
    <div ng-if="$root.ActiveRoute.locals.controller === 'weatherlandingcamera'" ng-cloak>
        <div ng-if="!$root.ActiveRoute.params['cam'] || $root.ActiveRoute.params['cam'] == ''" >
            <weather-traffic-cam-container-view camera-page-view-type="'weatherCamLandingPage'" ng-cloak/>
        </div>
        <!-- Weather Camera Detail page-->
        <div ng-if="$root.ActiveRoute.params['cam'] && $root.ActiveRoute.params['cam'] !== ''" >
            <weather-traffic-cam-container-view camera-page-view-type="'weatherCamDetailPage'" ng-cloak/>
        </div>
    </div>
    <div ng-if="$root.ActiveRoute.locals.controller === 'trafficlandingcamera'" ng-cloak>
        <div ng-if="!$root.ActiveRoute.params['latlng'] || $root.ActiveRoute.params['latlng'] == ''">
            <weather-traffic-cam-container-view camera-page-view-type="'trafficCamLandingPage'" ng-cloak/>
        </div>
        <!-- Traffic Camera's Detail page-->
        <div ng-if="$root.ActiveRoute.params['latlng'] && $root.ActiveRoute.params['latlng'] !== ''">
            <weather-traffic-cam-container-view camera-page-view-type="'trafficCamDetailPage'" ng-cloak/>
        </div>
    </div>  
    <div ng-if="$root.ActiveRoute.locals.controller === 'videolanding'" ng-cloak>
        <news-videos-page-container-view />
    </div>
    <div ng-if="$root.ActiveRoute.locals.controller === 'appdownload'" ng-cloak>
        <app-download-screen />
    </div>
    <div ng-if="$root.ActiveRoute.locals.controller == 'privacyPolicy'">
        <legal-policy-screen policyType='privacy'></legal-policy-screen>
    </div>
    <div ng-if="$root.ActiveRoute.locals.controller == 'termsOfUse'">
        <legal-policy-screen policyType='terms'></legal-policy-screen>
    </div>
    <div ng-if="$root.App.$route.current.originalPath == '/sitemap/'">
        <sitemap-page />
    </div>
    <div  ng-if="$root.ActiveRoute.locals.controller == 'faq'">
        <style>
            .module {
                background-image: none !important;
                background-color: #ffffff !important;
                border-top: 1px solid #d2d6d9 !important;
                border-bottom: 1px solid #d2d6d9 !important;
            }
        </style>
        <faq-page />
    </div>
    <div ng-if="$root.App.$route.current.originalPath == '/sitemap/:continent'">
        <locations-sitemap/>
    </div>
    <div ng-if="$root.App.$route.current.originalPath == '/sitemap/:continent/:country/:isocode'">
        <locations-sitemap/>
    </div>
    <div ng-if="$root.App.$route.current.originalPath == '/sitemap/:continent/:country/states'">
        <locations-sitemap/>
    </div>
    <div ng-if="$root.App.$route.current.originalPath == '/sitemap/:continent/:country/state/:state/:statecode'">
        <locations-sitemap/>
    </div>
    <div ng-if="$root.ActiveRoute.locals.controller == 'education'">
        <education-screen pageId="'education'"></education-screen>
    </div>
    <div ng-if="$root.ActiveRoute.locals.controller == 'weather-widgets'">
        <weather-widgets-screen pageId="'weather-widgets'"></weather-widgets-screen>
    </div>
    <div ng-if="$root.ActiveRoute.locals.controller == 'air-quality'">
        <style ng-if="!$root.isBreakpointMedium && !$root.isBreakpointSmall">
            .module {
                background-image: url('/images/backgrounds/Aqi_bg.jpeg') !important;
            }
        </style>
        <style ng-if="$root.isBreakpointMedium || $root.isBreakpointSmall">
            .module {
                background-image: none !important;
            }
        </style>
        <air-quality-wrapper />
    </div>
    <div ng-if="$root.ActiveRoute.locals.controller == 'hurricane' && $root.App.config.IsHurricaneSectionEnabled">
        <style>
            .module {
                background-image: none !important;
            }
        </style>
        <hurricane-landing-page />
    </div>
    <div ng-if="$root.ActiveRoute.locals.controller == 'partners'">
        <partners-screen pageId="'partners'"></partners-screen>
    </div>
    <div ng-if="$root.ActiveRoute.locals.controller == 'privacyfeedback'">
        <privacy-feedback />
    </div>
    <div ng-if="$root.RouteLoader === 'Module' && $root.ActiveRoute.locals.controller !== 'alerts'" ng-cloak>
        <div class="module-loader block-loader" wb-preloader color="white"></div>
    </div>
    <div ng-if="$root.ActiveRoute.locals.controller == 'uninstallapp'">
        <uninstall-app-screen pageId="'uninstallAppScreen'"></uninstall-app-screen>
    </div>
    <div ng-if="$root.ActiveRoute.locals.controller == 'press'">
        <style>
            .module {
                background-image: none !important;
                background-color: #f6f6f6 !important;
            }
        </style>
        <press-landing-page-wrapper />
    </div>
    <div ng-if="$root.ActiveRoute.locals.controller == 'pressArticle'">
        <style>
            .module {
                background-image: none !important;
                background-color: #f6f6f6 !important;
            }
        </style>
        <press-detail-page-wrapper />
    </div>
</div>
`
    };
};
WB.Modules.RoutesDirective.$inject = [];

WB.App.directive('wbModuleRoutes', WB.Modules.RoutesDirective);
